import styled from "styled-components";

import { colorsPalettes, elevation, rgba, setFontVariant } from "@similarweb/styles";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

export const MetricsWidgetContainer = styled(Stack)`
    border: 1px solid ${colorsPalettes.carbon["50"]};
    background: ${colorsPalettes.carbon["0"]};
    border-radius: 6px;
    padding: 16px 16px 24px 16px;
`;

export const MetricsGraphTooltipWrapper = styled(Flex)`
    && {
        gap: 8px;
        padding: 16px;
        border-radius: 3px;
        align-items: center;
        box-sizing: border-box;
        background-color: ${colorsPalettes.carbon[0]};
        box-shadow: ${elevation.Z3};
        ${setFontVariant("body2", colorsPalettes.carbon[500])}
    }
`;

export const MetricsLegendItem = styled.li<{ dotColor: string; value: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: space-between;
    width: 100%;

    ${setFontVariant("caption", rgba(colorsPalettes.carbon["500"], 0.8))}

    &::before {
        content: "";
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${(props) => props.dotColor};
    }

    &::after {
        content: "${(props) => props.value}";
        margin-left: auto;
        color: ${colorsPalettes.carbon[500]};
    }
`;

export const MetricsLegendList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 8px 0 0 0;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-family: Roboto, sans-serif;
    line-height: 18px;
    width: 100%;
    color: ${colorsPalettes.carbon[300]};
`;
